/**
 * Trust-focused Facebook / Marketplace paste text (link-first, no QR).
 */
export function buildFacebookShareText({
  title,
  price,
  vendorName,
  vendorBooth,
  marketName,
  itemId,
}) {
  const origin = (typeof window !== 'undefined' ? window.location.origin : '').replace(/\/$/, '');
  const link = origin ? `${origin}/item/${itemId}` : `/item/${itemId}`;
  const market = marketName || 'Traders Village San Antonio';
  const vendor = vendorName || 'Verified vendor';
  const booth = vendorBooth ? ` · Booth ${vendorBooth}` : '';
  const priceStr = Number(price).toFixed(2);

  return `✅ Official FleaMarketHub listing — ${title}

$${priceStr} · Pick up at ${market}

Verified vendor: ${vendor}${booth}
Pay in the app, pick up on market days. We do not ask for wire/Zelle off-site.

Secure link to view & buy:
${link}`;
}

/** Prefer fresh client copy; fall back to API-stored text with localhost link fixed. */
export function getShareTextForItem(item) {
  if (!item) return '';
  if (item.title && item.id != null) {
    return buildFacebookShareText({
      title: item.title,
      price: item.price,
      vendorName: item.vendorName,
      vendorBooth: item.vendorBooth,
      marketName: item.marketName,
      itemId: item.id,
    });
  }
  let text = item.facebookPrefillText || '';
  if (typeof window !== 'undefined' && item.id != null) {
    const link = `${window.location.origin.replace(/\/$/, '')}/item/${item.id}`;
    text = text.replace(/https?:\/\/[^\s]+/g, link);
  }
  return text;
}
